<template>
  <div class="home">
    <a-layout id="components-layout-demo-fixed" >
        <a-layout-header :style="{ position: 'fixed', zIndex: 999, width: '100%' }">
          <div class="logo"><img src="../assets/imgs/logo.png" height="31"></div>
          <a-menu theme="light" mode="horizontal" :selected-keys="[current]" :style="{ lineHeight: '62px' }">
            <a-menu-item key="1" @click="$router.push('/index')">首页</a-menu-item>
            <a-menu-item key="2" @click="$router.push('/quetaHome')">项目挂牌</a-menu-item>
            <a-menu-item key="3" @click="$router.push('/biddingHome')">项目竞价</a-menu-item>
            <a-menu-item key="4" v-if="token" @click="$router.push('/analysis')">项目分析</a-menu-item>
            <a-menu-item key="5" @click="$router.push('/industrialService')">产业服务</a-menu-item>
            <a-menu-item key="6" @click="$router.push('/supplyhome')">供求信息</a-menu-item>
            <!-- <a-menu-item key="7">存证</a-menu-item> -->
            <a-menu-item key="8" @click="$router.push('/news')">资讯</a-menu-item>
            <a-menu-item key="9" @click="$router.push('/aboutUs')">关于我们</a-menu-item>
          </a-menu>
          <div class="metadiv" v-if="!token">
              <span @click="$router.push('/login')">登录</span>/<span @click="$router.push('/register')">注册</span>
          </div>  
          <div class="userMeta metadiv" v-else>
               您好！{{ acount }}，
              <a-popover placement="bottom" v-model="visible">
                 <template slot="content">
                  <a-menu slot="overlay">
                      <a-menu-item @click="$router.push('/BuyerCenter'),visible=false">
                          我要投资
                      </a-menu-item>
                      <a-menu-item @click="$router.push('/SellerCentral'),visible=false">
                          我要出让
                      </a-menu-item>
                      <a-menu-item @click="$router.push('/user'),visible=false">
                          用户管理
                      </a-menu-item>
                      <a-menu-item @click="loginout">
                          退出登录
                      </a-menu-item>
                    </a-menu>
                </template>
                用户中心<a-icon type="user" style="cursor:pointer;margin-left:5px;" />
              </a-popover>
          </div>  
        </a-layout-header> 
    </a-layout>
    <router-view ></router-view>
    <div class="bottomSheep">
          <div v-for="(item,index) in bootsData" :key="index">
               <span>{{ item.categoryName }}</span>
               <span v-for="(ele,inx) in item.contentList" :key="inx" @click="todetail(ele)" style="cursor:pointer;">
                 {{ ele.contentTitle }}
               </span>
          </div>
    </div>  
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "Home",
  data(){
    return{
       userName:'',
       current:'',
       visible:false,
       bootsData:[],
    }
  },
  created(){
    this.getBottomSheep();
  },
  mounted(){
     let token = sessionStorage.getItem('token') || '';
     let account = sessionStorage.getItem('acount') || '';
     this.$store.dispatch('home/updateToken',token);
     this.$store.dispatch('home/setAcount',account);
  },
  computed:{
        ...mapState({
            acount:state=>state.home.acount, //产品列表
            token:state=>state.home.token
        })
    },
  methods:{
     loginout(){
       this.$https.delete('/portal/logout').then(res=>{
          if(res.code == 200){
              this.$message.success('退出成功')
              sessionStorage.removeItem('token');
              this.$store.dispatch('home/updateToken','');
              this.$router.push('/login');
          } 
       })
     },
     getBottomSheep(){
       this.$https.get('/portal/index/getBottom').then(res=>{
            this.bootsData = res
       })
     },
     todetail(item){
       if(item.contentMark){
         window.location.href = item.contentMark;
       }
     }
  }
};
</script>
<style lang="less" scoped>
#components-layout-demo-fixed{
  .ant-layout-header{
    border-top: 3px solid #ff8500;
  }
  height: 80px;
  .logo {
    width: 148px;
    height: 31px;
    margin: 16px 24px 16px 0;
    float: left;
    line-height: 31px;
  }
  .ant-menu{
    float: left;
  }
  .metadiv{
    float: right;
    font-size: 12px;
    span{
      cursor: pointer;
      &:hover{
        color:#ff8500;
      }
    }
  }
  .userMeta{
    font-size: 14px;
  }

}
/deep/.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left{
  border-right:none;
}
.bottomSheep{
     margin-top:30px;
     background-color: #05406a;
     display: flex;
     padding: 30px 100px;
     justify-content: space-between;
     div{
       color: #fff;
       display: flex;
       flex-direction: column;
       span{
         line-height: 30px;
       }
     }
}
</style>
